export enum ReferentielEnum {
    specialite = "RefSpecialite",
    organe = "RefOrgane",
    titre = "RefTitre",
    insHepat = "RefInsuffisanceHepatique",
    insCard = "RefInsuffisanceCardiaque",
    allaitement = "RefAllaitement",
    groupeSanguin = "RefGroupeSanguin",
    situationMaritale = "RefSituationMaritale",
    typePersonne = "RefTypePersonne",
    typeSuivi = "RefTypeSuivi",
    parente = "RefParente",
    codesPostaux = "CodesPostaux",
    typeVaccin = "RefTypeVaccin",
    medicament = "RefMedicament",
    pathologie = "RefPathologie",
    typeAntecedent = "RefTypeAntecedent",
    typeConsultation = "RefTypeConsultation",
    groupeConsultation = "RefGroupeConsultation",
    habitus = "RefHabitus",
    habitusTimeUnit = "habitusTimeUnit",
    qualite = "RefQualite",
    allergie = "RefAllergie",
    ald = "RefAld",
    allergene = "RefAllergene",
    tag = "tag",
    cim10 = "CIM10",
    identiteDocsHaut = "RefIdentiteDocsHaut",
    identiteDocsBas = "RefIdentiteDocsBas",
    identiteAttributOk = "RefIdentiteAttributOk",
    identiteAttributKo = "RefIdentiteAttributKo",
    typecode_dmp = "RefTypeCodeDMP", //JDV_J66-TypeCode-DMP.xml
    subjectrole_dmp = "RefSubjectRoleDMP", //JDV_J65-SubjectRole-DMP.xml
    restrictionaudience_dmp = "RefRestrictionAudienceDMP", //
    practicesettingcode_dmp = "RefPracticeSettingCodeDMP", //JDV_J62-PracticeSettingCode-DMP.xml
    healthcarefacilitytypecode_dmp = "RefHealthcareFacilityTypeCodeDMP", //JDV_J61-HealthcareFacilityTypeCode-DMP.xml
    formatcode_dmp = "RefFormatCodeDMP", //JDV_J60-FormatCode-DMP.xml
    contenttypecode_dmp = "RefContentTypeCodeDMP", //JDV_J59-ContentTypeCode-DMP.xml
    confidentialitycode_dmp = "RefConfidentialityCodeDMP", //JDV_J58-ConfidentialityCode-DMP.xml
    classcode_dmp = "RefClassCodeDMP", //JDV_J57-ClassCode-DMP.xml
    authorspecialty_dmp = "RefAuthorSpecialtyDMP", //JDV_J56-AuthorSpecialty-DMP.xml
    qualiterepresentantlegal_dmp = "RefQualiteRepresentantLegalDMP", //ASIP-SANTE_QualiteRepresentantLegal_20180326_DMP.xml
    obs_intolerance_type = 'RefObsIntoleranceType',
    act_status = 'RefActStatus',
    problem_code = 'RefProblemCode',
    personal_relationship_role_type = 'RefPersonalRelationshipRoleType',
    social_history_codes = 'RefSocialHistoryCodes',
    statut_tabagique = 'RefStatutTabagique',
    atc = 'RefAtc',
    acteCcam = 'RefActeCcam',
    ObservationIntoleranceType = 'ObservationIntoleranceType',
    SpecialiteSesamVitale = 'SpecialiteSesamVitale',
}
